import { useNavigate } from "react-router-dom";

import { Modal, ModalBody, ModalHeader, Button } from "design-react-kit";

const ChangePasswordModal = ({ modalOpen, modalCloseHandler }) => {
  const navigate = useNavigate();

  return (
    <Modal isOpen={modalOpen} toggle={modalCloseHandler}>
      <ModalHeader className="text-center">Password modificata!</ModalHeader>
      <ModalBody className="text-center">
        <p className="mb-4">
          Modifica avvenuta con successo, una email è stata inviata al tuo
          indirizzo. Ora puoi entrare col tuo account.
        </p>
        <div className="col-sm-12 mb-4 d-flex align-items-center justify-content-end">
          <Button
            style={{
              backgroundColor: "#5EB423",
              color: "#fff",
              padding: "7px 15px",
            }}
            onClick={(e) => navigate("/login")}
          >
            Vai al login
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ChangePasswordModal;
